import { createSelector } from 'reselect'
import { requestStatus } from '../../lib/Utils'

export const headersSelector = (state) =>
  (state.auth && state.auth.headers) || null
export const userSelector = (state) => (state.auth && state.auth.user) || null
export const signInStatusSelector = (state) =>
  state.auth && state.auth.signInStatus
export const resetPasswordStatusSelector = (state) =>
  state.auth && state.auth.resetPasswordStatus
export const requestAccessStatusSelector = (state) =>
  state.auth && state.auth.requestAccessStatus
export const jwtSelector = (state) => (state.auth && state.auth.jwt) || null

export const userPermissionsSelector = createSelector(
  [userSelector],
  (user) => (user && user.permissions) || [],
)

export const selectIsAuthenticated = createSelector(
  [userSelector],
  (user) => {
    return {
      isAuthenticated: user !== null,
    }
  },
)

export const selectGetJwt = createSelector(
  [jwtSelector],
  (jwt) => ({
    jwt,
  }),
)

export const selectIsSignInPending = createSelector(
  [signInStatusSelector],
  (status) => ({
    signInIsPending: status === requestStatus.pending,
  }),
)

export const selectIsSignInComplete = createSelector(
  [signInStatusSelector],
  (status) => ({
    signInIsComplete: status === requestStatus.complete,
  }),
)

export const selectIsSignInRejected = createSelector(
  [signInStatusSelector],
  (status) => ({
    signInIsRejected: status === requestStatus.rejected,
  }),
)

export const selectIsResetPasswordPending = createSelector(
  [resetPasswordStatusSelector],
  (status) => ({
    resetPasswordIsPending: status === requestStatus.pending,
  }),
)

export const selectIsResetPasswordComplete = createSelector(
  [resetPasswordStatusSelector],
  (status) => ({
    resetPasswordIsComplete: status === requestStatus.complete,
  }),
)

export const selectIsResetPasswordRejected = createSelector(
  [resetPasswordStatusSelector],
  (status) => ({
    resetPasswordIsRejected: status === requestStatus.rejected,
  }),
)

export const selectIsRequestAccessPending = createSelector(
  [requestAccessStatusSelector],
  (status) => ({
    requestAccessIsPending: status === requestStatus.pending,
  }),
)

export const selectIsRequestAccessComplete = createSelector(
  [requestAccessStatusSelector],
  (status) => ({
    requestAccessIsComplete: status === requestStatus.complete,
  }),
)

export const selectIsRequestAccessRejected = createSelector(
  [requestAccessStatusSelector],
  (status) => ({
    requestAccessIsRejected: status === requestStatus.rejected,
  }),
)
